<template>
        <div class="bg-secondary p-1">
            <form class="form-inline" @submit.prevent="saveZulp">
                <label class="mr-sm-2" for="operation">ZULP</label>

                <div class="col-md-5">
                    <multiselect v-model="selected" id="searchMedicine" label="label" track-by="code" placeholder="vyhledat lék" open-direction="bottom" :options="medicines" :multiple="false" :searchable="true" :internal-search="false" :close-on-select="true" :options-limit="300" :limit="3" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getMedicines" @select="selectMedicine" selectLabel="" :data-testid="'visit-zulp-search-' + actionId">
                        <template slot="option" scope="props">
                            <div class="option__desc"><span class="option__title" :class="props.option.available === true ? 'available' : 'unavailable'">{{ props.option.label }}</span></div>
                        </template>
                    </multiselect>
                </div>
              <v-popover v-if="selected">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary mr-sm-2"
                  title="informace o úhradách"
                  aria-label="informace o úhradách"
                  :data-testid="'visit-zulp-coverage-trigger-' + actionId"
                ><i class="fa fa-info-circle"></i></button>
                <template slot="popover">
                  <div :data-testid="'visit-zulp-coverage-popover-' + actionId">
                    <h3>Insurance Covers</h3>
                    <template v-for="ic in selected.actual_insruance_cover">
                      <div>
                        <h4>Úhrada {{ ic.sequence_number }}</h4>
                        <p v-if="ic.indication_limitation">{{ ic.indication_limitation.text }}</p>
                      </div>
                    </template>
                    <div class="container tooltip_container tooltip_1_col">
                    </div>
                  </div>
                </template>
              </v-popover>

              <!--<i title="interní výkon" v-if="zulp.internal" @click="changeInternal" class="fa fa-hand-spock-o fa-2x text-danger" aria-hidden="true"></i>
              <i title="běžný výkon" v-else="" @click="changeInternal" class="fa fa-hand-paper-o fa-2x text-light fa-flip-horizontal" aria-hidden="true"></i>-->
                <label for="amount" class="ml-sm-2 mr-sm-2">Množství</label>
                <input v-model="zulp.amount" type="number" step="0.01" min="0" max="999" class="form-control mr-sm-2 form-control-sm col-sm-1" aria-describedby="operationHelp" id="amount" :data-testid="'visit-zulp-amount-' + actionId">
                <template v-if="selected">
                  <label for="insuranceCoverSequenceNumber" class="ml-sm-2 mr-sm-2">Typ úhrady</label>
                  <select v-model="zulp.insuranceCoverSequenceNumber" class="form-control" aria-describedby="insuranceCoverSequenceNumber" id="insuranceCoverSequenceNumber" :data-testid="'visit-zulp-cover-' + actionId">
                    <option v-for="ic in selected.actual_insruance_cover" :value="ic.sequence_number">{{ ic.sequence_number }}</option>
                  </select>
                </template>

                <button v-if="!zulpPending" type="submit" id="addZulpButton" class="btn btn-sm btn-success" :data-testid="'visit-zulp-add-' + actionId">Přidat</button>
                <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
            </form>
        </div>
</template>

<script>
  // import { mapState, mapZulps } from 'vuex'
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        nic: 1,
        selected: null,
        // zulp (post)
        zulp: {
          medicine: '',
          amount: 1,
          insuranceCoverSequenceNumber: 1
        },
        zulpPending: false,
        zulpDone: false,
        zulpError: false,
        // Medicines
        medicines: [],
        medicinesError: false,
        medicinesPending: false
      }
    },
    props: ['actionId'],
    mixins: [apiMixin],
    methods: {
      showModalSelectedZULPInfo (zulp) {
        this.$emit('openOperationModal', zulp)
      },
      selectMedicine (val) {
        this.zulp.medicine = val.code
        document.getElementById('addZulpButton').focus()
      },
      saveZulp () {
        this.postZulp(this.actionId, this.zulp)
      },
      /* zulpAdded () {
        this.$emit('update', this.actionId)
      }, */
      selectOperation (val) {
        this.zulp.operation = val.code
        document.getElementById('addZulpButton').focus()
      },
      changeInternal () {
        this.zulp.internal = !this.zulp.internal
      }
    },
    beforeMount () {
    },
    watch: {
      zulpDone (val) {
        if (val === true) {
          this.zulp = {
            medicine: '',
            amount: 1,
            insuranceCoverSequenceNumber: 1
          }
          this.$emit('update')
          this.zulpDone = false
          // this.operations = []
          this.selected = null
          this.medicines = []
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.selected {
        background-color: deeppink;
    }

    .highlight_hovered tr:hover {
        background-color: #ffa;
    }

    .visit {
        background-color: orange;
        opacity: 0.5;
    }

    .visit-multi {
        background-color: orangered;
        opacity: 0.5;
    }

    .unoccupied{
        background-color: greenyellow;
        opacity: 0.5;
    }

    .hovered_window {
        opacity: 0.9;
    }

    .selected_window {
        background-color: green;
    }

    .hovered_window.visit {
        background-color: orangered;
    }

    .selected_window.visit {
        background-color: red;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }
</style>

<style>
    span.multiselect__option {
        min-height: 10px !important;
        padding: 6px !important;
    }

    span.option__title.available {
        color: #000;
        font-weight: bolder;
    }

    span.option__title.unavailable {
        color: #666;
    }


</style>



// WEBPACK FOOTER //
// src/views/Visit/components/AddZulp.vue?3705dd7c